/**
 * KindergartenCard.js
 * ════════════════════════════════════════════════════════════════
 * Картка садочка для сітки на сторінці пошуку/карти.
 * З обкладинкою (якщо є) і анімаціями:
 *   - staggered fade+slide-up при появі в сітці (index * delay)
 *   - повільний Ken Burns zoom фото на hover
 *   - підйом картки на hover
 * Якщо обкладинки немає — показується тільки текст (як раніше).
 * ════════════════════════════════════════════════════════════════
 */

import React, { useState, useEffect, useRef } from 'react';
import { constr_uri } from '../../../../../services/apiClient';
import './KindergartenCard.css';

// Скоригуй шлях до constr_uri під структуру проекту

const KindergartenCard = ({ kindergarten, highlighted = false, mapSelected = false, index = 0 }) => {
  const [entered, setEntered] = useState(false);
  const [settled, setSettled] = useState(false); // true = entrance-анімація завершена
  const cardRef = useRef(null);

  // Для картки — стиснута версія (мала вага). Фолбек на оригінал
  // для обкладинок, завантажених до появи thumbnail-генерації.
  const coverFileForCard = kindergarten.coverThumbFileId || kindergarten.coverFileId;
  const coverSrc = kindergarten.coverDocId && coverFileForCard
    ? constr_uri('docfile?doc_id=' + kindergarten.coverDocId + '&file_id=' + coverFileForCard)
    : null;

  // Staggered поява — невелика затримка пропорційно позиції в сітці,
  // обмежена зверху щоб довгі списки не чекали вічність
  useEffect(() => {
    const delay = Math.min(index, 11) * 45;
    const t = setTimeout(() => setEntered(true), delay);
    return () => clearTimeout(t);
  }, [index]);

  // Коли entrance-анімація (kg-card-fade-in) завершується — знімаємо клас
  // з animation і переходимо на статичний стан. Інакше animation: forwards
  // продовжує утримувати transform, і :hover transform (translateY) на
  // тому самому проперті просто ігнорується — CSS-анімації мають пріоритет
  // над transition для однієї і тієї ж властивості.
  const handleAnimationEnd = (e) => {
    if (e.target === cardRef.current) setSettled(true);
  };

  var stateClass = !entered ? 'kg-card-enter' : settled ? 'kg-card-visible' : 'kg-card-entered';

  return (
    <div
      ref={cardRef}
      className={`kindergarten-card ${highlighted ? 'highlighted' : ''} ${mapSelected ? 'map-selected' : ''} ${stateClass} ${coverSrc ? 'has-cover' : ''}`}
      onAnimationEnd={handleAnimationEnd}
    >
      {coverSrc && (
        <div className="kg-card-cover">
          <img src={coverSrc} alt="" loading="lazy" />
          <div className="kg-card-cover-gradient" />
        </div>
      )}

      <div className="card-content">
        <a href={`/object/${kindergarten._id}`} className="card-title-link">
          {[kindergarten.number, kindergarten.name].join(" ")}
        </a>
        <p className="card-district">{kindergarten.contacts.address.district}</p>
        <p className="card-address">{kindergarten.contacts.address.string}</p>
        <p className="card-phone">{kindergarten.contacts.phones.join(",")}</p>
      </div>
    </div>
  );
};

export default KindergartenCard;